module.exports = __webpack_public_path__ + "img/easy-eggless-cocoa-cake.1e4ca342.jpg";